'use strict';

export default function ShareableLinkService(
  $http,
  $location,
  $q,
  $state,
  CreativeService,
  RenderService,
  SettingsService
) {
  var isEdit;

  return {
    buildEmbedUrl: buildEmbedUrl,
    buildEditUrl: buildEditUrl,
    buildShareUrl: buildShareUrl
  };

  function baseUrl() {
    var port = '';
    if ($location.port() !== 80 && $location.port() !== 443) {
      port = ':' + $location.port();
    }

    return $location.protocol() + '://' + $location.host() + port + '/';
  }

  // passing in the ID for when we build this on the home page - otherwise
  // it's pulled from the state
  function buildShareUrl(id) {
    if (!CreativeService.creative) {
      return;
    }

    isEdit = false;

    var shareUrl = baseUrl();

    var type = ($state.current.data && $state.current.data.type) || 'demo';
    id = id || $state.params.id;

    // this is awful
    if (type === 'variant') {
      var variantId = CreativeService.creative.id;
      // "creatives/id/variantId?site=site"
      shareUrl += 'creatives/' + id + '/' + variantId;
    } else if (type === 'demo') {
      // "demo/id?site=site"
      shareUrl += 'demo/' + id;
    } else if (type === 'example') {
      // "example/id?site=site"
      shareUrl += 'example/' + id;
    } else if (type === 'appnexus') {
      // "dsp/appnexus/id?site=site"
      shareUrl += 'dsp/appnexus/' + id;
    } else if (type === 'campaign') {
      // "campaigns/id?site=site"
      shareUrl += 'campaigns/' + id;
    } else if (type === 'group') {
      shareUrl += 'groups/' + id;
    }

    shareUrl += '?' + buildUrlParams();

    return shareUrl;
  }

  function buildUrlParams() {
    var params = {};
    // both of these are legacy params from old whitelabel NAGs
    // that sadly still exit
    if (SettingsService.isWhiteLabel) {
      params.w = true;
    }

    if (SettingsService.deviceType) {
      params.deviceType = SettingsService.deviceType;
    }

    if (RenderService.site) {
      var siteId = RenderService.site.id;

      if (siteId) {
        params.siteId = siteId;
      } else {
        params.site = RenderService.site.url;
      }
    }

    if (isEdit) {
      params['edit-token'] = CreativeService.creative.privateKey;
    }

    // return $.param(params);
    return encodeParams(params);
  }

  function encodeParams(params) {
    return Object.keys(params)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join('&');
  }

  function buildEditUrl(id) {
    isEdit = true;
    id = id || $state.params.id;

    var shareUrl = baseUrl();

    shareUrl += 'edit/saved/' + id + '?' + buildUrlParams();

    return shareUrl;
  }

  function buildBannerEmbedUrl(creative) {
    if (!creative.id) {
      return '';
    }

    return `${baseUrl()}/embed?siteId=${RenderService.site.id}&creativeId=${
      creative.id
    }`;
  }

  function buildEmbedUrl(creative) {
    creative = creative || CreativeService.creative;

    if (creative.action === 'banner') {
      return buildBannerEmbedUrl(creative);
    }

    const headline = creative.headline || '';

    const thumbnailUrl = creative.thumbnailUrl || '';

    var embedUrl =
      baseUrl() +
      'embed?action=' +
      creative.action +
      '&headline=' +
      encodeURIComponent(headline) +
      '&description=' +
      encodeURIComponent(creative.description) +
      '&thumbnail_url=' +
      thumbnailUrl +
      '&advertiser=' +
      creative.advertiser +
      '&media_url=' +
      creative.mediaUrl +
      '&custom_engagement_url=' +
      encodeURIComponent(creative.customEngagementUrl) +
      '&custom_engagement_label=' +
      creative.customEngagementLabel +
      '&brand_logo_url=' +
      creative.brandLogoUrl +
      '&siteId=' +
      RenderService.site.id +
      '&force_click_to_play=' +
      creative.forceClickToPlay +
      '&slides=' +
      encodeURIComponent(JSON.stringify(creative.slides || [])) +
      '&slideshow_autoscroll=' +
      creative.slideshowAutoscroll +
      '&isi_autoscroll=' +
      creative.isiAutoscroll +
      '&isi_text=' +
      encodeURIComponent(creative.isiText || '');

    return embedUrl;
  }
}

ShareableLinkService.$inject = [
  '$http',
  '$location',
  '$q',
  '$state',
  'CreativeService',
  'RenderService',
  'SettingsService'
];
